import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Grid } from '@mui/material';
import { ONE_PAGE_SECTIONS } from 'constants/businessToolSections/onePage';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { FormHeader } from 'components/_basic/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import { FundingDirectionsContainer } from 'components/BusinessToolForm/Sections/ExecutiveSummary/FinancialNeedsExecSummary/components/FundingDirectionsContainer';
import { GLOBAL_FIELD_NAMES, globalPrefix } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

export const FinancingNeeds: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(ONE_PAGE_SECTIONS.FINANCING_NEEDS);

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader locked={!canAccess} title={t('chapters.FINANCING_NEEDS')} />
      </FormSectionCard>
      <FormSectionCard>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <NumberInputControlled
              control={control}
              id="onePage.financialNeeds.totalCostOfYourProject"
              name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TOTAL_COST)}
              label={t('executiveSummary.financialNeeds.totalCostOfYourProject')}
              adornmentType="currency"
              disabled={!canAccess}
              defaultValue=""
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <NumberInputControlled
              control={control}
              id="onePage.financialNeeds.fundingAmount"
              name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.FUNDING_AMOUNT)}
              label={t('executiveSummary.financialNeeds.fundingAmount')}
              adornmentType="currency"
              disabled={!canAccess}
              defaultValue=""
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <NumberInputControlled
              control={control}
              id="onePage.financialNeeds.percentageOfFundingToCover"
              name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PERCENTAGE_OF_FUNDING)}
              label={t('executiveSummary.financialNeeds.percentageOfFundingToCover')}
              adornmentType="percentage"
              disabled={!canAccess}
              defaultValue=""
            />
          </Grid>
        </Grid>
      </FormSectionCard>
      <FormSectionCard title={t('executiveSummary.financialNeeds.fundingDirections')} disabled={!canAccess}>
        <FundingDirectionsContainer disabled={!canAccess} />
      </FormSectionCard>
    </>
  );
};
